
import React from 'react';

interface SectionWrapperProps {
  id: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ 
  id, 
  title, 
  subtitle, 
  children, 
  className = "py-16 sm:py-20", 
  titleClassName = "text-3xl sm:text-4xl font-bold text-sky-700 mb-4 text-center",
  subtitleClassName = "text-lg text-slate-600 mb-10 sm:mb-12 text-center max-w-2xl mx-auto"
}) => {
  return (
    <section id={id} className={`w-full ${className}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className={titleClassName}>{title}</h2>
        {subtitle && <p className={subtitleClassName}>{subtitle}</p>}
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
